
import { observer } from "@legendapp/state/react";
import { INavPaths } from "../../../state/staticItems";
import SubCategoryContent from "./content/SubCategoryContent";

export interface ISubCategoryParams {
  isRoot?: boolean,
  path: INavPaths
}
//export default function SubCategory({ isRoot, path }: ISubCategoryParams) {
const SubCategory = observer(() => {

  return (
    <SubCategoryContent />
  )
})
export default SubCategory;
